import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MenuSettings } from 'src/app/models/menu-settings';
import { AppsSettings } from 'src/app/models/apps-settings';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TokenStorage } from 'src/app/core/token-storage';
import { ThemesService } from 'src/app/services/themes.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-menu-settings',
  templateUrl: './menu-settings.component.html',
  styleUrls: ['./menu-settings.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, NgClass],
})
export class MenuSettingsComponent implements OnInit {
  @Input() userConnected: any;
  @Input() menuSettings?: MenuSettings;
  @Input() cesarApplications: AppsSettings[] = [];

  currentTheme: string = '';

  private tokenStorage = inject(TokenStorage);

  constructor(private themesService: ThemesService) {}

  ngOnInit() {
    const userFromSession = sessionStorage.getItem('user');
    if (userFromSession) {
      this.userConnected = JSON.parse(userFromSession);
    } else {
      console.warn('Utilisateur non trouvé dans sessionStorage');
    }

    // Récupération du thème actuel
    this.themesService.currentTheme$.subscribe((theme) => {
      this.currentTheme = theme;
    });
  }

  getUrl(url: string): string {
    const token =
      this.userConnected?.token?.accessToken || this.tokenStorage.getToken();
    return `${url}?__access_token__=${token}`;
  }
}
